var browserPrinter = browserPrinter || {};

(function (bp) {

    var iFrameId = 'frame_a967b708-3e9b-4464-baaa-8d52a1f235a2';

    //Private Functions
    var _getFrame = function () {
        var f = (document.getElementById(this.iFrameId))
        if (f == null) {
            f = document.createElement("iframe");
            f.id = iFrameId;
            f.style = 'display:none;';
        }
        return f;
    }

    var _printFrameOnLoad = function () {
        var cw = this.contentWindow;
        cw.focus();
        cw.print();
        this.removeEventListener('load', _printFrameOnLoad, false);
    }

    //Public Functions
    bp.printUrl = function (relativeUrl) {
        var f = _getFrame();
        f.src = relativeUrl;
        f.addEventListener('load', _printFrameOnLoad, false)
        document.body.appendChild(f);
    }

})(browserPrinter);